import { APP_CONFIG } from "../constants/global-variables.js";
export async function bet(data) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/bet`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function checkOnHoldBetStatus(betId, data) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/betstatus/${betId}`;

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}

export async function cashout(betId) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/cashout`;

  try {
    const res = await axios.post(url, {
      bet_id: betId
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.log("Error getting documents");
  }
}